<template>
    <div>
        <el-select v-model="value" @change="changeParentData" :disabled="editLook == 2?true:false">
            <el-option v-for="item in dictionaryJson" :key="item.id" :label="item.dictCont" :value="text=='dengjuleixing' || text == 'zaitileixing'?item.id : item.dictCont"></el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    props:{
        text:{
            default:''
        },
        attrIndex:{
            default:''
        },
        formValue:{
            default:''
        },
        contestType:{
            default:''
        },
        editLook:{
            default:0
        }
    },
  data() {
    return {
        value:'',
        dictionaryJson:[]
    }
  },
  created(){
    
    this.value = this.formValue;
    this.getDictionary()
  },
  mounted(){
  },
  methods: { 
    // 字典接口调用
    getDictionary(){
        if(this.text=='dengjuleixing'){
            //加载灯具类型
            var self =this;
            this.$http.get('/api/dictionaryLampparam/lampparamDictTypeList', {
                indexPinyin: this.text,
                contestType:this.contestType
            }, function(res) {
                self.dictionaryJson = res.data;
            })
        }else{
            this.$http.getSync('/api/dictTypeAllList', {
                indexPinyin: this.text
            }, (res)=> {
                if (res.success) {
                    this.dictionaryJson = res.data
                }
            })
        }

    },
    // 改变父级对应数据
    changeParentData(){
        this.$emit('changeFormData',this.value,this.attrIndex)
    }
  }
};
</script>